import { _ as _sfc_main$1 } from "./chunks/p-info-icon.js";
import PTableFilterIcon from "./p-table-filter-icon.js";
import { defineComponent, resolveComponent, createElementBlock, openBlock, createElementVNode, createCommentVNode, createVNode, normalizeStyle, normalizeClass, toDisplayString, createBlock } from "vue";
import { _ as _export_sfc } from "./chunks/_plugin-vue_export-helper.js";
const DEFAULT_CLASSES = `text-xs leading-5 font-semibold truncate shrink`;
const _sfc_main = defineComponent({
  name: "PTableHeaderCell",
  components: {
    PTableFilterIcon,
    PInfoIcon: _sfc_main$1
  },
  props: {
    text: {
      type: String,
      default: ""
    },
    textClass: {
      type: [String, Object, Array],
      default: "text-left"
    },
    filterActive: {
      type: Boolean,
      default: false
    },
    showFilterIcon: {
      type: Boolean,
      default: false
    },
    tooltipText: {
      type: String,
      default: ""
    },
    textColor: {
      type: String,
      default: ""
    }
  },
  emits: ["click-filter-icon"],
  data() {
    return {
      DEFAULT_CLASSES
    };
  },
  computed: {
    textColorClass() {
      return this.filterActive ? "text-active-blue" : this.textColor ? "" : "text-p-gray-60";
    },
    style() {
      if (this.filterActive) {
        return {};
      }
      return {
        color: this.textColor
      };
    }
  }
});
const _hoisted_1 = { class: "flex items-center overflow-hidden" };
const _hoisted_2 = ["title"];
const _hoisted_3 = {
  key: 0,
  class: "relative ml-1 mr-auto h-3 w-3 shrink-0"
};
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_PInfoIcon = resolveComponent("PInfoIcon");
  const _component_PTableFilterIcon = resolveComponent("PTableFilterIcon");
  return openBlock(), createElementBlock("div", _hoisted_1, [
    createElementVNode("div", {
      class: normalizeClass([_ctx.DEFAULT_CLASSES, _ctx.textClass, _ctx.textColorClass, { "mr-auto": !_ctx.tooltipText }]),
      style: normalizeStyle(_ctx.style),
      title: _ctx.text
    }, toDisplayString(_ctx.text), 15, _hoisted_2),
    _ctx.tooltipText ? (openBlock(), createElementBlock("div", _hoisted_3, [
      _ctx.tooltipText ? (openBlock(), createBlock(_component_PInfoIcon, {
        key: 0,
        text: _ctx.tooltipText
      }, null, 8, ["text"])) : createCommentVNode("", true)
    ])) : createCommentVNode("", true),
    createVNode(_component_PTableFilterIcon, {
      class: normalizeClass(["ml-2", { hidden: !_ctx.showFilterIcon }]),
      active: _ctx.filterActive,
      onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("click-filter-icon", $event, _ctx.filterActive))
    }, null, 8, ["class", "active"])
  ]);
}
const PTableHeaderCell = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  PTableHeaderCell as default
};
